export const modalKey = 'import contract modal';

export const STANDARD = 'standard';
export const AI = 'ai';
